var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5, _react_refresh_temp_6;
var _react_refresh_temp_7;
_react_refresh_temp_7 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../../store';
import { resetExternalMediaPlayer } from '../../store/slices/externalMediaPlayer';
import VideoJsPlayerComponent from './video-js';
import ReactPlayerComponent from './reactPlayerComponent';
const isActiveSelector = createSelector(_react_refresh_temp_1 = (state) => {
    var _a;
    return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.external_media_player_features;
}, (external_media_player_features) => external_media_player_features === null || external_media_player_features === void 0 ? void 0 : external_media_player_features.is_active);
$RefreshReg$(_react_refresh_temp_1, "isActiveSelector$createSelector");
const playBackUrlSelector = createSelector(_react_refresh_temp_2 = (state) => {
    var _a;
    return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.external_media_player_features;
}, (external_media_player_features) => external_media_player_features === null || external_media_player_features === void 0 ? void 0 : external_media_player_features.url);
$RefreshReg$(_react_refresh_temp_2, "playBackUrlSelector$createSelector");
const actionSelector = createSelector(_react_refresh_temp_3 = (state) => state.externalMediaPlayer, (externalMediaPlayer) => externalMediaPlayer.action);
$RefreshReg$(_react_refresh_temp_3, "actionSelector$createSelector");
const seekToSelector = createSelector(_react_refresh_temp_4 = (state) => state.externalMediaPlayer, (externalMediaPlayer) => externalMediaPlayer.seekTo);
$RefreshReg$(_react_refresh_temp_4, "seekToSelector$createSelector");
const isPresenterSelector = createSelector(_react_refresh_temp_5 = (state) => { var _a; return (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata; }, (metadata) => metadata === null || metadata === void 0 ? void 0 : metadata.is_presenter);
$RefreshReg$(_react_refresh_temp_5, "isPresenterSelector$createSelector");
const ExternalMediaPlayer = () => {
    _react_refresh_temp_7();
    const playBackUrl = useAppSelector(playBackUrlSelector);
    const isActive = useAppSelector(isActiveSelector);
    const action = useAppSelector(actionSelector);
    const seekTo = useAppSelector(seekToSelector);
    const [showVideoJsPlayer, setShowVideoJsPlayer] = useState(false);
    const isPresenter = useAppSelector(isPresenterSelector);
    const dispatch = useAppDispatch();
    const AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
    const VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
    const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
    const DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
    useEffect(() => {
        if (playBackUrl) {
            dispatch(resetExternalMediaPlayer());
            setShowVideoJsPlayer(AUDIO_EXTENSIONS.test(playBackUrl) ||
                VIDEO_EXTENSIONS.test(playBackUrl) ||
                HLS_EXTENSIONS.test(playBackUrl) ||
                DASH_EXTENSIONS.test(playBackUrl));
        }
    }, [dispatch, playBackUrl]);
    const render = () => {
        return (_jsx("div", { className: "externalMediaPlayerWrapper m-auto w-full flex items-center justify-center max-w-[1000px] flex-1 p-4", children: _jsx("div", { className: "media-player-inner", children: showVideoJsPlayer ? (_jsx(VideoJsPlayerComponent, { src: playBackUrl !== null && playBackUrl !== void 0 ? playBackUrl : '', action: action, isPresenter: !!isPresenter, seekTo: seekTo })) : (_jsx(ReactPlayerComponent, { src: playBackUrl !== null && playBackUrl !== void 0 ? playBackUrl : '', action: action, isPresenter: !!isPresenter, seekTo: seekTo })) }) }));
    };
    return _jsx(_Fragment, { children: isActive && playBackUrl ? render() : null });
};
_react_refresh_temp_6 = ExternalMediaPlayer;
$RefreshReg$(_react_refresh_temp_6, "ExternalMediaPlayer");
_react_refresh_temp_7(ExternalMediaPlayer, "A+4aejheAPTQJMHAd0mryJI0/JM=", false, () => [useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppSelector, useAppDispatch]);
export default ExternalMediaPlayer;
